import { createContext, useContext } from "react";

/** Whether Drate's own pages show Regular in place of Free (plans.regular), from the page shell. */
export const RegularPlanContext = createContext(false);

export function useRegularPlan() {
  return useContext(RegularPlanContext);
}
